/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** Autogenerated input type of AddFontFacesToCurrentOrder */
export interface AddFontFacesToCurrentOrderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  faceIds: Array<number>;
  familyId: number;
  licenseOptionId: number;
}

/** Autogenerated input type of CompleteCurrentOrder */
export interface CompleteCurrentOrderInput {
  addressCompany?: string | null | undefined;
  addressCountryCode: string;
  addressLine1: string;
  addressLine2?: string | null | undefined;
  addressLocality: string;
  addressName: string;
  addressPostalCode: string;
  addressRegion?: string | null | undefined;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  licenseeEmail: string;
  licenseeName: string;
  paymentBraintreeNonce?: string | null | undefined;
  promotionCode?: string | null | undefined;
  receiveNewsletter?: boolean | null | undefined;
  studentIdImage?: string | null | undefined;
  studentInstitutionName?: string | null | undefined;
  studentProgramName?: string | null | undefined;
  vatNumber?: string | null | undefined;
}

/** Autogenerated input type of CompleteInvoice */
export interface CompleteInvoiceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  paymentBraintreeNonce?: string | null | undefined;
  slug: string;
}

/** Autogenerated input type of CreateSession */
export interface CreateSessionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  email: string;
  password: string;
}

/** Autogenerated input type of CreateUser */
export interface CreateUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  email: string;
  password: string;
  passwordConfirmation: string;
}

/** Autogenerated input type of DestroySession */
export interface DestroySessionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
}

export enum FontLicenseType {
  App = 'APP',
  Concept = 'CONCEPT',
  Custom = 'CUSTOM',
  Desktop = 'DESKTOP',
  Server = 'SERVER',
  Student = 'STUDENT',
  Web = 'WEB'
}

/** Autogenerated input type of GenerateInvoiceArchive */
export interface GenerateInvoiceArchiveInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  invoiceArchiveId: number;
}

/** Autogenerated input type of GenerateOrderArchive */
export interface GenerateOrderArchiveInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  orderArchiveId: number;
}

export enum InvoiceArchiveState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING'
}

export enum Language {
  De = 'DE',
  En = 'EN'
}

export enum OrderArchiveState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING'
}

/** Autogenerated input type of RemoveFontFacesFromCurrentOrder */
export interface RemoveFontFacesFromCurrentOrderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  faceIds: Array<number>;
  familyId: number;
  licenseOptionId: number;
}

/** Autogenerated input type of RemoveFontLicenseFromCurrentOrder */
export interface RemoveFontLicenseFromCurrentOrderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  id: number;
}

/** Autogenerated input type of RequestTrialFonts */
export interface RequestTrialFontsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  email: string;
  receiveNewsletter?: boolean | null | undefined;
}

/** Autogenerated input type of ResetPassword */
export interface ResetPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  email: string;
}

/** Autogenerated input type of UpdateCurrentOrder */
export interface UpdateCurrentOrderInput {
  addressCompany?: string | null | undefined;
  addressCountryCode?: string | null | undefined;
  addressLine1?: string | null | undefined;
  addressLine2?: string | null | undefined;
  addressLocality?: string | null | undefined;
  addressName?: string | null | undefined;
  addressPostalCode?: string | null | undefined;
  addressRegion?: string | null | undefined;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  licenseeIsLegalEntity?: boolean | null | undefined;
  promotionCode?: string | null | undefined;
  vatNumber?: string | null | undefined;
}

/** Autogenerated input type of UpdateCurrentUser */
export interface UpdateCurrentUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  email?: string | null | undefined;
  name?: string | null | undefined;
  organization?: string | null | undefined;
  password?: string | null | undefined;
}

/** Autogenerated input type of UpdatePassword */
export interface UpdatePasswordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: string | null | undefined;
  password: string;
  passwordConfirmation: string;
  resetPasswordToken: string;
}

export type UpdateCurrentUserMutationVariables = Exact<{
  input: UpdateCurrentUserInput;
}>;


export interface UpdateCurrentUserMutation { __typename: 'Mutation', updateCurrentUser: { __typename: 'UpdateCurrentUserPayload', success: boolean, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null, user: { __typename: 'User', id: number, name: string | null, email: string, organization: string | null } | null } | null }

export type CartLinkQueryVariables = Exact<{ [key: string]: never; }>;


export interface CartLinkQuery { __typename: 'Query', currentOrder: { __typename: 'Order', id: number, fontLicenses: Array<{ __typename: 'FontLicense', id: number }> } | null }

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export interface CreateUserMutation { __typename: 'Mutation', createUser: { __typename: 'CreateUserPayload', success: boolean, user: { __typename: 'User', id: number, email: string, name: string | null, organization: string | null, orders: Array<{ __typename: 'Order', id: number, number: string, total: number, completedAt: string | null, archive: { __typename: 'OrderArchive', id: number } | null }>, invoices: Array<{ __typename: 'Invoice', id: number, number: string, slug: string, formattedTotal: string, date: string }> } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type BraintreeQueryVariables = Exact<{ [key: string]: never; }>;


export interface BraintreeQuery { __typename: 'Query', braintree: { __typename: 'Braintree', environment: string, clientToken: string } }

export type RemoveFontLicenseFromCurrentOrderMutationVariables = Exact<{
  input: RemoveFontLicenseFromCurrentOrderInput;
  language: Language;
}>;


export interface RemoveFontLicenseFromCurrentOrderMutation { __typename: 'Mutation', removeFontLicenseFromCurrentOrder: { __typename: 'RemoveFontLicenseFromCurrentOrderPayload', order: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type UpdateCurrentOrderMutationVariables = Exact<{
  input: UpdateCurrentOrderInput;
  language: Language;
}>;


export interface UpdateCurrentOrderMutation { __typename: 'Mutation', updateCurrentOrder: { __typename: 'UpdateCurrentOrderPayload', success: boolean, order: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type CompleteCurrentOrderMutationVariables = Exact<{
  input: CompleteCurrentOrderInput;
  language: Language;
}>;


export interface CompleteCurrentOrderMutation { __typename: 'Mutation', completeCurrentOrder: { __typename: 'CompleteCurrentOrderPayload', success: boolean, order: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type OrderArchiveQueryVariables = Exact<{
  id: number;
}>;


export interface OrderArchiveQuery { __typename: 'Query', orderArchive: { __typename: 'OrderArchive', id: number, state: OrderArchiveState, fileUrl: string | null } | null }

export type GenerateOrderArchiveMutationVariables = Exact<{
  input: GenerateOrderArchiveInput;
}>;


export interface GenerateOrderArchiveMutation { __typename: 'Mutation', generateOrderArchive: { __typename: 'GenerateOrderArchivePayload', success: boolean, orderArchive: { __typename: 'OrderArchive', id: number, state: OrderArchiveState, fileUrl: string | null } | null } | null }

export type PageQueryVariables = Exact<{
  id: string;
  language: Language;
}>;


export interface PageQuery { __typename: 'Query', page: { __typename: 'Page', id: string, content: string | null } | null }

export type DestroySessionMutationVariables = Exact<{
  input: DestroySessionInput;
}>;


export interface DestroySessionMutation { __typename: 'Mutation', destroySession: { __typename: 'DestroySessionPayload', success: boolean } | null }

export type FontFaceDeclarationsQueryVariables = Exact<{
  faceIds?: Array<number> | number | null | undefined;
}>;


export interface FontFaceDeclarationsQuery { __typename: 'Query', fontFaces: Array<{ __typename: 'FontFace', id: number, cssFontFaceDeclaration: string | null }> }

export type FontFamilyQueryVariables = Exact<{
  slug: string;
  language: Language;
}>;


export interface FontFamilyQuery { __typename: 'Query', fontFamily: { __typename: 'FontFamily', id: number, slug: string, name: string, completePrice: number, fontFacePrice: number, subPackageFontFacePrice: number, discountedFontFacePrice: number, description: string | null, supportedLanguages: Array<string>, micrositeUrl: string | null, specimenDocumentUrl: string | null, conceptFont: boolean, backgroundColor: string | null, textColor: string | null, hideFontFacePreviews: boolean, hasWidthVariableFiles: boolean, headerMediaAspectRatio: string | null, headerMediaHasAudio: boolean, characterSetImage: { __typename: 'Image', url: string | null, width: number | null, height: number | null }, faces: Array<{ __typename: 'FontFace', id: number, description: string, cssClassName: string, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, style: { __typename: 'FontStyle', id: number, slug: string, name: string, position: number }, familyPreview: { __typename: 'Image', url: string | null, width: number | null, height: number | null }, singlePreview: { __typename: 'Image', url: string | null }, singleCharacterPreview: { __typename: 'Image', url: string | null }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, typeTesters: Array<{ __typename: 'FontTypeTester', id: number, position: number | null, faceId: number, content: string, fontSize: number, lineHeight: number, openTypeFeatures: string }>, features: Array<{ __typename: 'FontFeature', id: number, name: string, image: { __typename: 'Image', url: string | null } }>, usageExamples: Array<{ __typename: 'FontUsageExample', id: number, title: string, designers: Array<string>, permalink: string, image: { __typename: 'Image', url: string | null, width: number | null, height: number | null } }>, headerMedia: { __typename: 'Image', url: string | null, width: number | null, height: number | null, url800w: string | null, url1400w: string | null, url2000w: string | null, url2600w: string | null } } | null }

export type FamilyHeaderMediaFragment = { __typename: 'FontFamily', headerMediaAspectRatio: string | null, headerMediaHasAudio: boolean, headerMedia: { __typename: 'Image', url: string | null, width: number | null, height: number | null, url800w: string | null, url1400w: string | null, url2000w: string | null, url2600w: string | null } };

export type FontLicenseOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export interface FontLicenseOptionsQuery { __typename: 'Query', fontLicenseOptions: Array<{ __typename: 'FontLicenseOption', id: number, type: FontLicenseType, minValue: number, maxValue: number, multiplier: number, description: string }> }

export type RequestTrialFontsMutationVariables = Exact<{
  input: RequestTrialFontsInput;
}>;


export interface RequestTrialFontsMutation { __typename: 'Mutation', requestTrialFonts: { __typename: 'RequestTrialFontsPayload', success: boolean } | null }

export type AddFontFacesToCurrentOrderMutationVariables = Exact<{
  input: AddFontFacesToCurrentOrderInput;
  language: Language;
}>;


export interface AddFontFacesToCurrentOrderMutation { __typename: 'Mutation', addFontFacesToCurrentOrder: { __typename: 'AddFontFacesToCurrentOrderPayload', order: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type RemoveFontFacesFromCurrentOrderMutationVariables = Exact<{
  input: RemoveFontFacesFromCurrentOrderInput;
  language: Language;
}>;


export interface RemoveFontFacesFromCurrentOrderMutation { __typename: 'Mutation', removeFontFacesFromCurrentOrder: { __typename: 'RemoveFontFacesFromCurrentOrderPayload', order: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type InvoiceArchiveQueryVariables = Exact<{
  id: number;
}>;


export interface InvoiceArchiveQuery { __typename: 'Query', invoiceArchive: { __typename: 'InvoiceArchive', id: number, state: InvoiceArchiveState, fileUrl: string | null } | null }

export type GenerateInvoiceArchiveMutationVariables = Exact<{
  input: GenerateInvoiceArchiveInput;
}>;


export interface GenerateInvoiceArchiveMutation { __typename: 'Mutation', generateInvoiceArchive: { __typename: 'GenerateInvoiceArchivePayload', success: boolean, invoiceArchive: { __typename: 'InvoiceArchive', id: number, state: InvoiceArchiveState, fileUrl: string | null } | null } | null }

export type CompleteInvoiceMutationVariables = Exact<{
  input: CompleteInvoiceInput;
}>;


export interface CompleteInvoiceMutation { __typename: 'Mutation', completeInvoice: { __typename: 'CompleteInvoicePayload', success: boolean, errors: Array<{ __typename: 'Error', message: string }> | null, invoice: { __typename: 'Invoice', id: number, agreedToLicenses: boolean, agreedToLicensesAt: string | null, paid: boolean, paidAt: string | null, customArchiveFileUrl: string | null, allowArchiveDownload: boolean, archive: { __typename: 'InvoiceArchive', id: number, state: InvoiceArchiveState, fileUrl: string | null } | null } | null } | null }

export type InvoiceLicensesQueryVariables = Exact<{
  slug: string;
}>;


export interface InvoiceLicensesQuery { __typename: 'Query', invoice: { __typename: 'Invoice', id: number, lineItems: Array<{ __typename: 'QuoteLineItem', id: number, licenseType: string, licenseAgreement: string | null, pdfUrl: string | null }> } | null }

export type InvoiceTermsAndConditionsQueryVariables = Exact<{
  language: Language;
}>;


export interface InvoiceTermsAndConditionsQuery { __typename: 'Query', page: { __typename: 'Page', id: string, content: string | null } | null }

export type InvoiceQueryVariables = Exact<{
  slug: string;
}>;


export interface InvoiceQuery { __typename: 'Query', invoice: { __typename: 'Invoice', id: number, slug: string, number: string, date: string, customerName: string, discount: number, formattedDiscount: string, locale: string, currency: string, formattedSubtotal: string, formattedPreDiscountTotal: string, vatTotal: number, formattedVatTotal: string, total: number, formattedTotal: string, agreedToLicenses: boolean, agreedToLicensesAt: string | null, braintreePaymentEnabled: boolean, hidePrices: boolean, paid: boolean, paidAt: string | null, customArchiveFileUrl: string | null, allowArchiveDownload: boolean, allowArchiveDownloadBeforePayment: boolean, allLineItemFontFacesMatch: boolean, combined: boolean, combinedLineItemName: string, combinedLineItemTypefaces: Array<string>, formattedCombinedLineItemTotal: string, termsAndConditions: string | null, customerAddress: { __typename: 'Address', id: number, company: string | null, line1: string, line2: string | null, line3: string | null, locality: string, region: string | null, postalCode: string, countryName: string | null } | null, lineItems: Array<{ __typename: 'QuoteLineItem', id: number, formattedPrice: string | null, licenseType: string, fontLicenseExtent: string, hasLicenseAgreement: boolean, pdfUrl: string | null, fontFamily: { __typename: 'FontFamily', id: number, name: string }, fontFaces: Array<{ __typename: 'FontFace', id: number, description: string }> }>, adjustments: Array<{ __typename: 'QuoteAdjustment', id: number, formattedTotal: string | null, formattedDescription: string | null }>, archive: { __typename: 'InvoiceArchive', id: number, state: InvoiceArchiveState, fileUrl: string | null } | null } | null }

export type OrderQueryVariables = Exact<{
  number: string;
  language: Language;
}>;


export interface OrderQuery { __typename: 'Query', order: { __typename: 'Order', id: number, number: string, licenseeName: string | null, licenseeEmail: string | null, subtotal: number, taxTotal: number, total: number, completedAt: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number }, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, description: string, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, style: { __typename: 'FontStyle', id: number, slug: string, name: string, position: number } }> }>, archive: { __typename: 'OrderArchive', id: number } | null, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, locality: string, region: string | null, postalCode: string, countryCode: string } | null } | null }

export type QuestionGroupsQueryVariables = Exact<{
  language: Language;
}>;


export interface QuestionGroupsQuery { __typename: 'Query', questionGroups: Array<{ __typename: 'QuestionGroup', id: number, position: number, slug: string, title: string, questions: Array<{ __typename: 'Question', id: number, position: number, slug: string, content: string, answer: string }> }> }

export type InUseQueryVariables = Exact<{ [key: string]: never; }>;


export interface InUseQuery { __typename: 'Query', fontUsageExamples: Array<{ __typename: 'FontUsageExample', id: number, title: string, designers: Array<string>, permalink: string, image: { __typename: 'Image', url: string | null }, family: { __typename: 'FontFamily', id: number, name: string, slug: string } }> }

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export interface UpdatePasswordMutation { __typename: 'Mutation', updatePassword: { __typename: 'UpdatePasswordPayload', success: boolean, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export interface ResetPasswordMutation { __typename: 'Mutation', resetPassword: { __typename: 'ResetPasswordPayload', success: boolean } | null }

export type CreateSessionMutationVariables = Exact<{
  input: CreateSessionInput;
}>;


export interface CreateSessionMutation { __typename: 'Mutation', createSession: { __typename: 'CreateSessionPayload', success: boolean, user: { __typename: 'User', id: number, email: string, name: string | null, organization: string | null, orders: Array<{ __typename: 'Order', id: number, number: string, total: number, completedAt: string | null, archive: { __typename: 'OrderArchive', id: number } | null }>, invoices: Array<{ __typename: 'Invoice', id: number, number: string, slug: string, formattedTotal: string, date: string }> } | null, errors: Array<{ __typename: 'Error', attribute: string | null, message: string }> | null } | null }

export type CountriesQueryVariables = Exact<{
  language: Language;
}>;


export interface CountriesQuery { __typename: 'Query', countries: Array<{ __typename: 'Country', name: string, alpha3: string, alpha2: string }> }

export type CurrentOrderFragment = { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null };

export type CurrentOrderQueryVariables = Exact<{
  language: Language;
}>;


export interface CurrentOrderQuery { __typename: 'Query', currentOrder: { __typename: 'Order', id: number, number: string, licenseeEmail: string | null, licenseeName: string | null, licenseeIsLegalEntity: boolean | null, adjustmentsTotal: number, subtotal: number, taxTotal: number, total: number, studentInstitutionName: string | null, studentProgramName: string | null, vatNumber: string | null, fontLicenses: Array<{ __typename: 'FontLicense', id: number, total: number, family: { __typename: 'FontFamily', id: number, name: string }, faces: Array<{ __typename: 'FontFace', id: number, size: { __typename: 'FontSize', id: number, slug: string, name: string, position: number }, width: { __typename: 'FontWidth', id: number, slug: string, name: string, position: number }, weight: { __typename: 'FontWeight', id: number, slug: string, name: string, position: number }, family: { __typename: 'FontFamily', id: number, fontFacePrice: number, discountedFontFacePrice: number } }>, licenseOption: { __typename: 'FontLicenseOption', id: number, type: FontLicenseType, maxValue: number } }>, adjustments: Array<{ __typename: 'Adjustment', id: number, amount: number, description: string }>, address: { __typename: 'Address', id: number, name: string, company: string | null, line1: string, line2: string | null, region: string | null, locality: string, postalCode: string, countryCode: string } | null } | null }

export type CurrentUserFragment = { __typename: 'User', id: number, email: string, name: string | null, organization: string | null, orders: Array<{ __typename: 'Order', id: number, number: string, total: number, completedAt: string | null, archive: { __typename: 'OrderArchive', id: number } | null }>, invoices: Array<{ __typename: 'Invoice', id: number, number: string, slug: string, formattedTotal: string, date: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export interface CurrentUserQuery { __typename: 'Query', currentUser: { __typename: 'User', id: number, email: string, name: string | null, organization: string | null, orders: Array<{ __typename: 'Order', id: number, number: string, total: number, completedAt: string | null, archive: { __typename: 'OrderArchive', id: number } | null }>, invoices: Array<{ __typename: 'Invoice', id: number, number: string, slug: string, formattedTotal: string, date: string }> } | null }

export type FontFamiliesQueryVariables = Exact<{ [key: string]: never; }>;


export interface FontFamiliesQuery { __typename: 'Query', fontFamilies: Array<{ __typename: 'FontFamily', id: number, name: string, slug: string, position: number, conceptFont: boolean, variableWeightMin: number, variableWeightMax: number, variableLineHeight: number, variableMarginBottom: number, variableFontUrl: string | null, variableFontFallbackUrl: string | null, textColor: string | null, homePageTextColor: string | null, widthsCount: number, facesCount: number, variableFontsCount: number }> }
